/* The addresses the step's form holds. */
export type AddressPrefix = "shippingAddress";

/**
 * What the address form holds while the employee types: HOP's field names, every field a string, plus the
 * phone country code and the delivery instructions. Never saved or sent to HOP as is; see ValidatedAddress in
 * replacement.types.
 */
export interface AddressFormValues {
  country: string;
  line1: string;
  line2: string;
  line3: string;
  city: string;
  state: string;
  zip: string;
  county: string;
  countryCode: string;
  phoneNumber: string;
  deliveryInstructions: string;
}

export type ChooseDeliveryFormState = Record<AddressPrefix, AddressFormValues>;

/** A form field path such as "shippingAddress.zip". */
export type AddressFormField = `${AddressPrefix}.${keyof AddressFormValues}`;

export const EMPTY_ADDRESS_FORM_VALUES: AddressFormValues = {
  country: "",
  line1: "",
  line2: "",
  line3: "",
  city: "",
  state: "",
  zip: "",
  county: "",
  countryCode: "",
  phoneNumber: "",
  deliveryInstructions: "",
};
